import { lazy } from 'react';

import { ALLOWED_ROLES, REMOTE_CONFIG_KEYS, withRemoteConfigKey } from '@src/packages/utils';

import { withEmergencyCommandCenterAccess } from './components/EmergencyCommandCenterAccessGate';
import { PATHS } from './constants';

const EmergencyCommandCenter = withEmergencyCommandCenterAccess(
  lazy(() => import('./screens/EmergencyCommandCenter')),
);
const EmergencyMonitoring = withEmergencyCommandCenterAccess(
  lazy(() => import('./screens/EmergencyMonitoring')),
);
const EmergencyHistory = withEmergencyCommandCenterAccess(
  lazy(() => import('./screens/EmergencyHistory')),
);
const EmergencyTypeList = lazy(() => import('./screens/EmergencyTypeList'));
const EmergencyTypeForm = lazy(() => import('./screens/EmergencyTypeForm'));
const EmergencyIntegrations = lazy(() => import('./screens/EmergencyIntegrations'));
const EmergencyIntegrationForm = lazy(() => import('./screens/EmergencyIntegrationForm'));

const emergencyRoutes = [
  {
    component: EmergencyHistory,
    path: PATHS.HISTORY,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.EMERGENCIES.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.HISTORY}`,
  },
  {
    component: EmergencyTypeForm,
    path: PATHS.CREATE_TYPE,
    writeOnly: true,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.EMERGENCY_TYPES.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.TYPES}`,
  },
  {
    component: EmergencyTypeForm,
    path: PATHS.EDIT_TYPE,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.EMERGENCY_TYPES.UPDATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.TYPES}`,
  },
  {
    component: EmergencyTypeList,
    path: PATHS.TYPES,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.EMERGENCY_TYPES.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.TYPES}`,
  },
  {
    component: EmergencyIntegrationForm,
    path: PATHS.CREATE_INTEGRATION,
    writeOnly: true,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.EMERGENCY_INTEGRATIONS.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.INTEGRATIONS}`,
  },
  {
    component: EmergencyIntegrationForm,
    path: PATHS.EDIT_INTEGRATION,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.EMERGENCY_INTEGRATIONS.UPDATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.INTEGRATIONS}`,
  },
  {
    component: EmergencyIntegrations,
    path: PATHS.INTEGRATIONS,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.EMERGENCY_INTEGRATIONS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.INTEGRATIONS}`,
  },
  {
    component: EmergencyMonitoring,
    path: PATHS.MONITORING,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.EMERGENCIES.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.MONITORING}`,
  },
  {
    component: EmergencyCommandCenter,
    // Keep list and detail on one Route instance so closing a selected incident
    // updates the URL without remounting the map and resetting its viewport.
    path: `${PATHS.COMMAND_CENTER}/:incidentId?`,
    exact: true,
    allowedRoles: [
      ...ALLOWED_ROLES.ORGANIZATIONS.EMERGENCIES.GET,
      ...ALLOWED_ROLES.ORGANIZATIONS.EMERGENCIES.LIST,
    ],
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.COMMAND_CENTER}`,
  },
];

export default withRemoteConfigKey(REMOTE_CONFIG_KEYS.EMERGENCIES, emergencyRoutes);
